import React from 'react'

export interface PhoneNumbersProps {
	numbers: string | string[]
}

const PhoneNumber: React.FunctionComponent<{ number: string }> = ({
	number,
}) => {
	const plink = React.useMemo(() => {
		return number.split(' ').join('').trim()
	}, [number])

	return <a href={`tel:${encodeURIComponent(plink)}`}>{number.replace(/ /g, ' ')}</a>
}

export const PhoneNumbers: React.FunctionComponent<PhoneNumbersProps> = ({
	numbers,
}) => {
	const arr = React.useMemo(() => {
		const a = Array.isArray(numbers) ? numbers : numbers.split(',');
		return a.map(ph => ph.trim()).filter(p => p);
	}, [numbers])

	return (
		<>
			{arr.map((number, i) => (
				<React.Fragment key={i}>
					{i !== 0 && <>&nbsp;&nbsp;</>}
					<PhoneNumber number={number.trim()} />
				</React.Fragment>
			))}
		</>
	)
}
